import { render, staticRenderFns } from "./PanelWithQuizEditor.vue?vue&type=template&id=2535131a&lang=pug&"
import script from "./PanelWithQuizEditor.vue?vue&type=script&lang=ts&"
export * from "./PanelWithQuizEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithQuizEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports